import { render, staticRenderFns } from "./BookingCommodity.vue?vue&type=template&id=479371b2&"
import script from "./BookingCommodity.vue?vue&type=script&lang=js&"
export * from "./BookingCommodity.vue?vue&type=script&lang=js&"
import style0 from "./BookingCommodity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports